export default class Tree {
    constructor(object, children) {
        this.object = object;
        if (children === null) {
            children = [];
        }
        if (Array.isArray(children)) {
            this.children = children;
        } else {
            this.children = [children];
        }
    }

    getObject() {
        return this.object;
    }

    getChildren() {
        return this.children;
    }
}
